import { BodyType } from '../services/BodyType';

export class Body {
	public constructor(
		public readonly id: string,
		public readonly name: string,
		public readonly type: BodyType,
	) {}

	public get formattedId(): string {
		return this.id.padStart(4, '0');
	}
}
